import { Eye, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { NotificationItem } from "@/lib/notification.api";
import { cn } from "@/lib/utils";
import { CATEGORY_ICONS, CATEGORY_LABELS } from "../notification.constants";
import { formatNotificationDateTime } from "../notification.formatters";
import { NotificationSeverityBadge } from "./NotificationSeverityBadge";

export function NotificationRow({
  item,
  onOpen,
  onDismiss,
  dismissing,
}: {
  item: NotificationItem;
  onOpen: (item: NotificationItem) => void;
  onDismiss: (id: number) => void;
  dismissing: boolean;
}) {
  const CategoryIcon = CATEGORY_ICONS[item.category];
  const unread = !item.readAt;

  return (
    <div
      className={cn(
        "grid gap-3 px-4 py-3 transition-colors hover:bg-surface-muted md:grid-cols-[minmax(0,1fr)_auto]",
        unread && "bg-brand-gold-light/15",
      )}
    >
      <button
        type="button"
        onClick={() => onOpen(item)}
        className="grid min-w-0 gap-3 text-left sm:grid-cols-[24px_120px_minmax(0,1fr)] sm:items-center"
      >
        <span className="flex items-center gap-2 sm:justify-center">
          {unread && <span className="h-2 w-2 rounded-full bg-brand-gold-dark" />}
          <CategoryIcon size={15} className="text-subtle" />
        </span>

        <span className="min-w-0">
          <span className="block text-[11px] font-medium text-muted-foreground">
            {CATEGORY_LABELS[item.category]}
          </span>
          <span className="block text-[10.5px] text-subtle">
            {formatNotificationDateTime(item.createdAt)}
          </span>
        </span>

        <span className="min-w-0">
          <span className="flex min-w-0 flex-wrap items-center gap-2">
            <span
              className={cn(
                "truncate text-[13px] text-foreground",
                unread ? "font-bold" : "font-semibold",
              )}
            >
              {item.title}
            </span>
            <NotificationSeverityBadge severity={item.severity} />
          </span>
          <span className="mt-1 block truncate text-[12px] text-muted-foreground">{item.body}</span>
        </span>
      </button>

      <div className="flex items-center justify-end gap-1">
        <Button type="button" variant="ghost" size="icon" title="Voir" onClick={() => onOpen(item)}>
          <Eye size={13} />
        </Button>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          title="Archiver"
          onClick={() => onDismiss(item.id)}
          disabled={dismissing}
        >
          {dismissing ? <Loader2 size={13} className="animate-spin" /> : <X size={13} />}
        </Button>
      </div>
    </div>
  );
}
